import { EntidadeBase } from 'hay-core-react';
class UsuarioGrupoModel extends EntidadeBase {
    constructor() {
        super('usuariogrupo');
    }
}

const instance = new UsuarioGrupoModel();
export default instance;
